import React, { useEffect, useState } from 'react';
import { Download } from 'lucide-react';

export default function InstallPWA() {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(() => window.matchMedia?.('(display-mode: standalone)').matches || navigator.standalone);
  const [guide, setGuide] = useState(false);
  useEffect(() => {
    const ready = event => { event.preventDefault(); setPrompt(event); };
    const done = () => { setInstalled(true); setPrompt(null); };
    window.addEventListener('beforeinstallprompt', ready);
    window.addEventListener('appinstalled', done);
    return () => { window.removeEventListener('beforeinstallprompt', ready); window.removeEventListener('appinstalled', done); };
  }, []);
  if (installed) return null;
  const install = async () => {
    if (!prompt) { setGuide(value => !value); return; }
    try { await prompt.prompt(); await prompt.userChoice; }
    catch { setGuide(true); }
    finally { setPrompt(null); }
  };
  return <section className="club-section club-panel">
    <h2 className="club-section-title">TAP를 홈 화면에</h2>
    <p className="text-muted-foreground text-sm mb-3">브라우저에서 매번 주소를 입력하지 않고 바로 열 수 있어요.</p>
    <button className="club-button" onClick={install} aria-expanded={guide}><Download size={18} aria-hidden="true" />홈 화면에 추가</button>
    {guide && <div className="mt-4 text-sm text-muted-foreground space-y-2"><p>iPhone: Safari의 공유 메뉴에서 ‘홈 화면에 추가’를 선택하세요.</p><p>Android: 브라우저 메뉴에서 ‘앱 설치’ 또는 ‘홈 화면에 추가’를 선택하세요.</p><p>컴퓨터: 지원하는 브라우저의 주소창 또는 메뉴에서 앱 설치를 선택하세요.</p><p>경기 기록 조회와 저장에는 인터넷 연결이 필요합니다.</p></div>}
  </section>;
}
